import AddIcon from "../../components/Icons/AddIcon";
import Button from "../../components/Shared/Button";
import { useState } from "react";
import Spinner from "../../components/Shared/Spinner";
import { useUserDataStore } from "../../stores/user";
import { useQuery } from "@tanstack/react-query";
import { GetAllCategories } from "../../api/Categories/GetAllCategories";
import AddCategory from "../../components/Dashboard/Category/AddCategory";

const Categories = () => {
  const [showAddCourse, setShowAddCourse] = useState(false);
  const { userData } = useUserDataStore();
  const { data: CategoriesResponse, isLoading: isCategoriesLoading } = useQuery(
    {
      queryFn: GetAllCategories,
      queryKey: ["categories"],
      staleTime: 0,
      refetchInterval: 0,
    }
  );
  const categories = CategoriesResponse?.data || [];

  const handleAddCourseSuccess = () => {
    setShowAddCourse(false);
  };

  if (isCategoriesLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <div>
      {showAddCourse ? (
        <AddCategory onSuccess={handleAddCourseSuccess} />
      ) : (
        <div>
          <div className="flex justify-between items-center py-7">
            <h1 className="text-burntBlack font-bold text-[32px]">
              Categories
            </h1>
            {userData?.role === "admin" && (
              <div className="flex space-x-4">
                <Button
                  onClick={() => setShowAddCourse(true)}
                  className="!h-12 w-44 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                  variant="primary"
                >
                  <AddIcon className="mr-1.5" />
                  Add New Category
                </Button>
              </div>
            )}
          </div>
          <div className="grid grid-cols-3 place-content-between gap-6 pb-40">
            {categories.map((category) => (
              <div
                key={category.id}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="relative w-full h-48">
                  {category.img_url ? (
                    <img
                      src={category.img_url}
                      alt={category.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                      <span className="text-gray-400 text-lg">
                        No image available
                      </span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-burntBlack mb-3">
                    {category.name}
                  </h3>
                  <p className="text-gray-600 mb-4 min-h-[48px]">
                    {category.description || "No description available"}
                  </p>
                  <div className="text-sm text-gray-500">
                    Created: {new Date(category.createdAt).toLocaleDateString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Categories;
